import request from '@/utils/request'

// 查询专业管理列表
export function listMajors(query) {
  return request({
    url: '/OmdMajors/majors/list',
    method: 'get',
    params: query
  })
}

// 查询专业管理详细
export function getMajors(majorId) {
  return request({
    url: '/OmdMajors/majors/' + majorId,
    method: 'get'
  })
}

// 新增专业管理
export function addMajors(data) {
  return request({
    url: '/OmdMajors/majors',
    method: 'post',
    data: data
  })
}

// 修改专业管理
export function updateMajors(data) {
  return request({
    url: '/OmdMajors/majors',
    method: 'put',
    data: data
  })
}

// 删除专业管理
export function delMajors(majorId) {
  return request({
    url: '/OmdMajors/majors/' + majorId,
    method: 'delete'
  })
}
